module.exports = __webpack_public_path__ + "img/signup-guide-01-01.5dac77ad.png";